import React from 'react';
import PortfolioPageContainer from './portfolio.styles';
import PortfolioBox from './../../components/portfolio-box/portfolio-box.component';
import MainHeading from './../../components/main-heading/main-heading.component';
import Container from './../../components/container/container.component';

const PortfolioPage = () => {
    return (
        <PortfolioPageContainer id="Portfolio">
            <Container>
                <div className="container">
                    <MainHeading title="Portfolio" />
                </div>
                <div className="imgs-container">
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/gytXD3q/shuffle-01.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/bLkkmXp/shuffle-02.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/vsYBtdy/shuffle-03.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/NNL2Myw/shuffle-04.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/FBQQ4jP/shuffle-05.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/mCJ6kv1/shuffle-06.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/MCY0xsV/shuffle-07.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                    <PortfolioBox
                        imageUrl="https://i.ibb.co/rck2Fsy/shuffle-08.jpg"
                        name="Awesome Image"
                        type="Photography"
                    />
                </div>
                <a href="test" className="more">
                    More
                </a>
            </Container>
        </PortfolioPageContainer>
    );
};
export default PortfolioPage;
